export const HTTP_DEFAULT_TIMEOUT = 3000;
